import InAppNotificationItem from '@/components/notifications/InAppNotificationItem';
import type { NotificationData } from '@/types/layout.types';

interface LiveNotificationsListProps {
	notifications: NotificationData[];
	onClose: (id: string) => void;
	isMobile: boolean;
}

export function LiveNotificationsList({
	notifications,
	onClose,
	isMobile,
}: LiveNotificationsListProps) {
	if (!notifications || notifications.length === 0) return null;

	return (
		<div
			className={`fixed z-[99999] w-full px-4 flex ${
				isMobile
					? 'top-15 left-1/2 -translate-x-1/2 justify-center'
					: 'top-4 right-4 flex-col items-end'
			}`}
		>
			{notifications.map((n) => (
				<InAppNotificationItem key={n.id} notification={n} onClose={() => onClose(n.id)} />
			))}
		</div>
	);
}
